/* globals process Promise*/
import client from './client';
import backupKeys from '@/lang/keys/backup-keys.lang';
import lscache from 'lscache';

//Create a client that can connect to contentful, pulling in the appropriate env vars from our webpack configuration.
function sync() {
  return new Promise(function(resolve) {
    lscache.flushExpired();
    let keys = lscache.get(
      'contentfulKeys' + process.env.VUE_APP_CONTENTFUL_CACHE_PREFIX,
    );

    if (keys) {
      resolve(keys);
    } else {
      client
        .getEntries({
          content_type:
            process.env.VUE_APP_CONTENTFUL_LOCALIZATION_CONTENT_TYPE,
          limit: 1000,
        })
        .then((response) => {
          let keys = Object.assign(hydrate(), parseContent(response.items));
          store(keys);
          resolve(keys);
        })
        .catch(() => {
          resolve(backupKeys);
        });
    }
  });
}

function parseContent(content) {
  return content.reduce((keys, value) => {
    keys[value.fields.key] = value.fields.textValue;
    return keys;
  }, {});
}

function hydrate() {
  let keys = lscache.get(
    'contentfulKeys' + process.env.VUE_APP_CONTENTFUL_CACHE_PREFIX,
  );
  if (keys) {
    return keys;
  } else {
    return {};
  }
}
function store(keys) {
  lscache.set(
    'contentfulKeys' + process.env.VUE_APP_CONTENTFUL_CACHE_PREFIX,
    keys,
    1440,
  );
}

export default sync;
